import { render, staticRenderFns } from "./RemoveEndDateDialog.vue?vue&type=template&id=164db886&scoped=true"
import script from "./RemoveEndDateDialog.vue?vue&type=script&lang=js"
export * from "./RemoveEndDateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164db886",
  null
  
)

export default component.exports